import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Building, Search, CheckCircle, ExternalLink } from 'lucide-react';

export default function EmployersTab({ employers, search, setSearch }) {
  const filteredEmployers = employers.filter(e => 
    !search || 
    e.company_name.toLowerCase().includes(search.toLowerCase()) ||
    e.industry?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search employers..." className="pl-9 rounded-full" />
      </div>

      {filteredEmployers.length > 0 ? (
        <div className="grid sm:grid-cols-2 gap-4">
          {filteredEmployers.map(emp => (
            <Card key={emp.id} className="border-0 shadow-sm rounded-2xl">
              <CardContent className="p-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center shrink-0">
                    <Building className="w-5 h-5 text-amber-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm">{emp.company_name}</p>
                    <p className="text-xs text-muted-foreground">{emp.industry}</p>
                    {emp.felony_friendly && (
                      <Badge className="bg-emerald-50 text-emerald-700 text-xs mt-1">
                        <CheckCircle size={10} className="mr-1" /> Second Chance
                      </Badge>
                    )}
                    {emp.description && <p className="text-xs text-muted-foreground mt-2 line-clamp-2">{emp.description}</p>}
                    <div className="flex gap-2 mt-3">
                      {emp.application_link && (
                        <Button size="sm" variant="outline" className="rounded-full text-xs" onClick={() => window.open(emp.application_link, '_blank')}>
                          <ExternalLink size={12} className="mr-1" /> Apply
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="border-2 border-dashed rounded-2xl">
          <CardContent className="py-12 text-center">
            <Building className="w-12 h-12 text-muted-foreground/30 mx-auto mb-3" />
            <p className="text-muted-foreground">No employers in directory yet.</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
